import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface CategoryCardProps {
  title: string;
  description: string;
  image: string;
  color: string;
  delay?: number;
  href?: string;
}
export function CategoryCard({
  title,
  description,
  image,
  color,
  delay = 0,
  href = '#'
}: CategoryCardProps) {
  const CardContent = <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -8
  }} className="group relative h-[400px] rounded-3xl overflow-hidden cursor-pointer" data-id="element-324">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-325">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-326" />
        <div className={`absolute inset-0 bg-gradient-to-t ${color} opacity-60 group-hover:opacity-70 transition-opacity duration-300`} data-id="element-327" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" data-id="element-328" />
      </div>

      {/* Content */}
      <div className="absolute inset-0 p-8 flex flex-col justify-end text-white" data-id="element-329">
        <h3 className="font-serif text-3xl font-bold mb-2 transform translate-y-0 transition-transform duration-300 group-hover:-translate-y-2" data-id="element-330">
          {title}
        </h3>
        <p className="text-white/90 mb-6 opacity-0 transform translate-y-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0" data-id="element-331">
          {description}
        </p>

        <div className="flex items-center font-medium text-sm tracking-wide uppercase" data-id="element-332">
          <span className="mr-2" data-id="element-333">Explore</span>
          <ArrowRight className="w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-2" data-id="element-334" />
        </div>
      </div>
    </motion.div>;
  return href !== '#' ? <Link to={href} data-id="element-335">{CardContent}</Link> : CardContent;
}